import { useState, useCallback, useMemo,useEffect } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Swal from "sweetalert2";
import RequestServices from "../../../services/RequestServies";
import RequisitionEdit from "./RequisitionEdit";

const RejectionApproval = () => {
  const [gridInsideModal, setGridInsideModal] = useState(false);
  const [test, setTest] = useState(0);
  const [selectedItem, setSelectedItem] = useState(null);
  const [open, setOpen] = useState(true);
  const [formNumber, setFormNumber] = useState("");
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  const handleSearch = useCallback(async () => {
    if (!formNumber.trim()) {
      Swal.fire("Error", "Please enter Requisition number", "error");
      return;
    }

    setLoading(true);
    try {
      const res = await RequestServices.getAllItemApproval(formNumber);
      const responseData = res?.data?.data || [];
      setReportData(responseData);
      setTotalCount(responseData.length);
    } catch (error) {
      Swal.fire(
        "Error",
        error.response?.data?.message || "Something went wrong",
        "error"
      );
    } finally {
      setLoading(false);
    }
  });
  
  useEffect(() => {
    if (test > 0) {
      handleSearch();
    }
  }, [test]);
  const formatDate = (isoString) => {
    if (!isoString) return "N/A";
    return new Date(isoString).toLocaleString("en-GB", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);
    setGridInsideModal(true);
  };

  const tableRows = useMemo(
    () =>
      reportData.length ? (
        reportData.map((item, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>{item?.requisitionNo?.store?.name}</td>
            <td>{item?.requisitionNo?.requisitionNo}</td>
            <td>{item?.inventory?.masterItem?.partNo}</td>
            <td className="scrollable-description">{item?.inventory?.masterItem?.description}</td>
            <td>{item?.inventory?.masterItem?.unit?.name}</td>
            <td>{item?.qtyRequired}</td>
            <td>{item?.approveQty}</td>
            <td>{item?.status}</td>
            <td>{formatDate(item?.createdAt)}</td>
            <td>
              <button className="btn btn-primary btn-xs sharp" onClick={() => handleEditClick(item)}>
                <i className="fa fa-pencil"></i>
              </button>
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="11" className="text-center">No Data Available For Modfication</td>
        </tr>
      ),
    [reportData]
  );

  return (
    <>
      <RequisitionEdit
        item={selectedItem}
        show={gridInsideModal}
        test={setTest}
        handleClose={() => setGridInsideModal(false)}
      />
      <div className="row">
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className="content-title">
              <div className="cpa">
                <i className="fas fa-filter me-2"></i>Filter
              </div>
              <div className="tools">
                <Link to="#" className={`SlideToolHeader ${open ? "collapse" : "expand"}`} onClick={() => setOpen(!open)}>
                  <i className={`fas ${open ? "fa-angle-down" : "fa-angle-up"}`}></i>
                </Link>
              </div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-6 col-xxl-6">
                      <label className="ms-2">Enter Requisition Number</label>
                      <input
                        type="text"
                        placeholder="Enter Form Number"
                        className="form-control mb-xxl-0 mb-3"
                        value={formNumber}
                        onChange={(e) => setFormNumber(e.target.value)}
                      />
                    </div>
                    <div className="col-xl-6 col-xxl-6">
                      <label className="ms-2">Search</label>
                      <button className="form-control btn btn-primary" onClick={handleSearch} disabled={loading}>
                        {loading ? "Loading..." : "Search"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>

          <div className="filter cm-content-box box-primary">
            <div className="content-title d-flex justify-content-between align-items-center">
              <div className="cpa">
                <i className="fa fa-list me-2"></i>Requisition Voucher Items
                <span className="badge bg-orange ms-2">{totalCount}</span>
              </div>
            </div>
            <div className="cm-content-body form excerpt">
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Store</th>
                        <th>Requisition No.</th>
                        <th>Part No</th>
                        <th>Description</th>
                        <th>Unit</th>
                        <th>Required Qty</th>
                        <th>Approved Qty</th>
                        <th>Status</th>
                        <th>Created Date</th>
                        <th className="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody>{tableRows}</tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RejectionApproval;
